export const state = () => ({
	invites: {},
});
export const mutations = {
	setInvite(state: any, payload: any) {
		state.invites = payload;
	},
};
export const getters = {
	getInvites: (state: any) => state.invites,
};
export const actions = {
	async newInvite(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/company/' + payload.company_uuid + '/invitations', payload.obj)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getInvites(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/company/' + payload.company_uuid + '/invitations')
				.then((res) => {
					state.commit('setInvite', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async AcceptInvite(state: any, payload: any) {
		await this.$axios.get('sanctum/csrf-cookie');

		const token = payload.token.split('=')[1];
		return new Promise((resolve, reject) => {
			this.$axios
				.post('api/invitations/' + token, payload.obj)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteInvite(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/company/invitations/' + payload.invite)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
